import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MaskedInput from 'react-text-mask';
import Tooltip from '../Tooltip';
import './style.scss';

const Input = forwardRef((props, ref) => {
  const { label, tooltip, className, isErrorVisible, errorMessage, value, offset, isMasked, isDisabled, hasError, placeHolder, isRequired, isBadgeVisible, ...restProps } = props;
  const [isFocused, setIsFocused] = useState(false);
  const [isRequiredInternal, setIsRequiredInternal] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    if (e.target && e.target.value) {
      setIsRequiredInternal(false);
    } else {
      setIsRequiredInternal(isRequired);
    }
    !isRequired && setIsFocused(false);
  };

  return (
    <div className={cn(
      {
        'has-value': !isDisabled && (isFocused || value.length || hasError || isRequired),
        active: isFocused || value.length || isRequired,
        required: !isDisabled && ((isRequiredInternal && !value.length) || hasError),
        disabled: isDisabled,
      },
      'form-group',
      'inputWrapper'
    )}
    >
      <label>
        <span>
          {label}
          {
            (isRequired && isBadgeVisible) && (
              <em>
                {isRequired && hasError !== 'The input field is required' && hasError && 'Error'}
                {!isRequired && hasError !== 'The input field is required' && hasError && 'Error'}
                {isRequired && (hasError === 'The input field is required' || !hasError) && 'Required'}
              </em>
            )
          }
        </span>
        {
          isMasked ? (
            <MaskedInput
              className={className}
              value={value}
              mask={isMasked}
              disabled={isDisabled}
              placeholder={(isFocused || value.length || isDisabled || hasError) ? placeHolder : ''}
              onFocus={handleFocus}
              onBlur={handleBlur}
              {...restProps}
              ref={ref}
            />
          ) : (
            <input
              className={className}
              value={value}
              disabled={isDisabled}
              placeholder={(isFocused || value.length || isDisabled || hasError) ? placeHolder : ''}
              onFocus={handleFocus}
              onBlur={handleBlur}
              {...restProps}
              ref={ref}
            />
          )
        }
        {isErrorVisible && (
        <div className="error" style={{ color: '#D82028' }}>
          {errorMessage !== 'The input field is required' && errorMessage}
        </div>
        )}
      </label>
      {tooltip && <Tooltip offset={offset}>{tooltip}</Tooltip>}
    </div>
  );
});

Input.propTypes = {
  label: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  tooltip: PropTypes.any,
  isDisabled: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  isMasked: PropTypes.any,
  placeHolder: PropTypes.string,
  onChange: PropTypes.func,
  offset: PropTypes.number,
  errorMessage: PropTypes.string,
  isRequired: PropTypes.bool,
  isBadgeVisible: PropTypes.bool,
  isErrorVisible: PropTypes.bool,
};

Input.defaultProps = {
  className: '',
  value: '',
  isDisabled: false,
  hasError: false,
  placeHolder: '',
  isMasked: false,
  onChange: () => {},
  tooltip: '',
  offset: 1,
  isRequired: false,
  errorMessage: '',
  isBadgeVisible: true,
  isErrorVisible: true,
};

export default Input;
